import {ApiContractImplTechnology} from '../';
import {EnumHelper} from './enum-helper';

export class ApiContractImplTechnologyHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in ApiContractImplTechnology ) {
      this._values.push(ApiContractImplTechnology[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): ApiContractImplTechnology {

    for ( const obj in ApiContractImplTechnology ) {
      if (ApiContractImplTechnology[obj] === value){
        return ApiContractImplTechnology[obj] as ApiContractImplTechnology;
      }
    }
  }
}

const ApiContractImplTechnologyHelper = new ApiContractImplTechnologyHelperEnumHelperClass();
export default ApiContractImplTechnologyHelper;
